class Compare extends HTMLElement {
    constructor() {
      super();
      this.openCompareBtn = this.querySelector('.open-compare');
      this.closeCompareBtn = this.querySelector('.close-compare-list');
      this.compareList = this.querySelector('.compare-products-wrapper');
      this.openComparePopupBtn = this.querySelector('.compare-products-btn');
      this.closeComparePopupBtn = this.querySelector('.compare-close');
      this.closeComparePopupBtn2 = this.querySelector('.compare-close-btn');
      this.comparePopup = this.querySelector('.compare-section-overlay');

      // Listeners
      this.openCompareBtn.addEventListener('click', this.openCompareList.bind(this));
      this.closeCompareBtn.addEventListener('click', this.closeCompareList.bind(this));
      this.openComparePopupBtn.addEventListener('click', this.openComparePopup.bind(this));
      this.closeComparePopupBtn.addEventListener('click', this.closeComparePopup.bind(this));
      this.closeComparePopupBtn2.addEventListener('click', this.closeComparePopup.bind(this));
    }
  
    openCompareList(){
        this.compareList.classList.add('open');
        this.classList.add('compare-list-opened');
        this.renderProductList()
    }

    closeCompareList(){
        this.compareList.classList.remove('open');
        this.classList.remove('compare-list-opened');
    }

    openComparePopup(){
        this.renderProductPopup();
        this.comparePopup.classList.add('open');
        this.classList.add('compare-popup-opened');
        this.closeCompareList();
    }

    closeComparePopup(){
        this.comparePopup.classList.remove('open');
        this.classList.remove('compare-popup-opened');
    }

    renderProductList(){
        let products = JSON.parse(localStorage.getItem('compare-products'));
        let productsContainer = document.querySelector('.compare-products-list');
        let html = '';
        productsContainer.innerHTML = '';
        products.forEach(product => {
            html = `
            <div class="compare-products-item">
                <button class="remove-from-list" onclick="CompareBtn.prototype.removeFromCompare(${product.id})"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 100 125" style="enable-background:new 0 0 100 100;" xml:space="preserve"><g><path d="M15.7,84.3c1.6,1.9,4.2,2.8,6.5,2.8s4.6-0.9,6.5-2.8L50,63l21.3,21.3c1.9,1.9,4.2,2.8,6.5,2.8c2.3,0,4.6-0.9,6.5-2.8   c3.7-3.7,3.7-9.5,0-13.2L63.2,50.1l21.3-21.3c3.7-3.7,3.7-9.5,0-13.2c-3.7-3.7-9.5-3.7-13.2,0L50,36.9L28.7,15.6   c-3.7-3.7-9.5-3.7-13.2,0c-3.7,3.7-3.7,9.5,0,13.2l21.3,21.3L15.5,71.4C12,75.1,12,80.9,15.7,84.3z"/></g></svg></button>
                <div class="compare-products-item-img">
                ${product.img}
                </div>
                <div class="compare-products-item-content">
                    <div class="compare-products-item-name">${product.title}</div>
                    <div class="compare-products-item-price">${product.price}</div>
                </div>
            </div>
            `;
            productsContainer.innerHTML = productsContainer.innerHTML + html;
        });
    }

    checkMetafields(products , metafield){
        let result = false;
       
        products.forEach((item)=>{
            if(item[metafield] != '' && item[metafield] != ' '){
                result = true;
            }
        })
        
        return result;
    }

    findMinCo2e(products){
        let minCo2e = false;
        let minCo2eId = false;
       products.forEach((item)=>{
            if(minCo2e == false){
                minCo2e = +item.co2e;
                minCo2eId = item.id;
            }else{
                if(+item.co2e < minCo2e){
                    minCo2e = +item.co2e;
                    minCo2eId = item.id;
                }
            }
       })

        return {
            "count": minCo2e,
            "id": minCo2eId
        };
    }

    renderProductPopup(){
        let products = JSON.parse(localStorage.getItem('compare-products'));
        let productsList = this.querySelector('.compare-section-products');
        let html = '';
        productsList.innerHTML = '';
        let material = '';
        let colour = '';
        let country = '';
        
        let containsMOQ = this.checkMetafields(products,'moq');
        let containsLeadTime = this.checkMetafields(products,'leadtime');
        let containsCo2e = this.checkMetafields(products,'co2e');
        console.log(this.findMinCo2e(products));
        let minCo2eCount = this.findMinCo2e(products).count;
        let minCo2eID = this.findMinCo2e(products).id;

        products.forEach(product => {
            product.tags.forEach((tag)=>{
                if(tag.name == 'Material'){
                    material = tag.value;
                }else if(tag.name == 'Colour'){
                    colour = tag.value;
                }else if(tag.name == 'Country of Origin'){
                    country = tag.value;
                }
            })

            html = `
            <div class="compare-section-item">
                    ${minCo2eCount != 0 && minCo2eID == product.id ? `<div class="min-co2e-label">Lowest <br> CO2e”</div>` : ''}
                    <div class="compare-section-item-media">
                        ${product.img}
                    </div>
                    <div class="compare-section-item-content">
                        <div class="compare-section-item-name">${product.title}</div>
                        <div class="compare-section-item-price">${product.price}</div>
                        <div class="compare-section-item-info">
                            <div class="compare-info-item">
                                <div class="compare-info-item-title">Material</div>
                                <div class="compare-info-item-value">${material}</div>
                            </div>
                            <div class="compare-info-item">
                                <div class="compare-info-item-title">Colour</div>
                                <div class="compare-info-item-value">${colour}</div>
                            </div>
                            <div class="compare-info-item">
                                <div class="compare-info-item-title">Country of Origin</div>
                                <div class="compare-info-item-value">${country}</div>
                            </div>
                            ${containsMOQ ? `<div class="compare-info-item">
                                <div class="compare-info-item-title">MOQ</div>
                                <div class="compare-info-item-value">${product.moq}</div>
                            </div>` : ''}
                            ${containsLeadTime ? `<div class="compare-info-item">
                            <div class="compare-info-item-title">Lead time</div>
                            <div class="compare-info-item-value">${product.leadtime}</div>
                        </div>` : ''}
                        ${containsCo2e ? `<div class="compare-info-item">
                            <div class="compare-info-item-title">CO2e</div>
                            <div class="compare-info-item-value">${product.co2e}</div>
                        </div>` : ''}
                        </div>
                        <a href="${product.url}" class="compare-section-item-link">Show Product</a>
                    </div>
            </div>
            `;
            productsList.innerHTML = productsList.innerHTML + html;
        });
    }
}

customElements.define('compare-products', Compare);

class CompareBtn extends HTMLElement{
    constructor(){
        super();
        this.addEventListener('click', this.addToCompare.bind(this));
    }

    addToCompare(event){
        let currentItems = JSON.parse(localStorage.getItem('compare-products'));
        let data = this.getAttribute('data-compare-product');
        data = JSON.parse(data);
        let dataId = +this.getAttribute('data-id');

        

        if(currentItems == null){
            let items = [];
            items.push(data);
            localStorage.setItem('compare-products',JSON.stringify(items));
            this.changeCountLabel();
            this.classList.add('added');
        }else{
            let items = JSON.parse(localStorage.getItem('compare-products'));
            let inStorage;
            items.forEach((item)=>{
                if(item.id == dataId){
                    inStorage = true;
                }
            })
           
            if(inStorage == true){
                this.removeFromCompare(dataId);
                this.changeCountLabel();
            }else{
               if(items.length < 5){
                this.classList.add('added');
                items.push(data);
                localStorage.setItem('compare-products',JSON.stringify(items));
                this.changeCountLabel();
               }
            }
            
           
        }

    }

    removeFromCompare(id){
        let currentItems = JSON.parse(localStorage.getItem('compare-products'));

        let items = currentItems.filter(function(value, index){
            return value.id != id;
        })
        localStorage.setItem('compare-products',JSON.stringify(items));
        Compare.prototype.renderProductList();
        if(document.querySelector(`.compare-btn[data-id="${id}"]`) != null){
            document.querySelector(`.compare-btn[data-id="${id}"]`).classList.remove('added');
        }
        
        this.changeCountLabel();
    }

    changeCountLabel(){
        let currentItems = JSON.parse(localStorage.getItem('compare-products'));
        let openBtn = document.querySelector('.open-compare');
        let countLabel = document.querySelector('.open-compare .count');

        if(currentItems != null){
            let count = currentItems.length;
            if(currentItems.length > 0){
                countLabel.textContent = count;
                openBtn.classList.add('active');
            }else{
                countLabel.textContent = count;
                openBtn.classList.remove('active');
            }
        }else{
            countLabel.textContent = '';
            openBtn.classList.remove('active');
        }
        
    }

    checkAddedProducts(){
        let currentItems = JSON.parse(localStorage.getItem('compare-products'));
        
       if(currentItems != null){
            currentItems.forEach((item)=>{
                if(document.querySelector(`compare-button[data-id="${item.id}"]`) != null){
                    document.querySelector(`compare-button[data-id="${item.id}"]`).classList.add('added');
                }
            })
       }
    }
}
customElements.define('compare-button', CompareBtn);



window.onload = function(){
    CompareBtn.prototype.changeCountLabel();
    CompareBtn.prototype.checkAddedProducts();
}